<template>
<div class="bodyclass">
<!--首页大框-->
<div class="top-box-ins"> 
  <!--菜单-->
  <div class="top-menu">
    <div class="top-menu-t clearfloat">
      <div class="menu-logo fl"></div>
      <div class="menu-txt fl">
        <ul class="li-div-txt">
          <li><a class="dbi fb w100 menu-atxt" href="/">首页</a></li>
          <li> <a class="dbi fb w100 menu-atxt" href="/chanping1" >产品</a>
            <div class="li-div" style="width:1000px;">
              <div class="li-div-left fl"> <span class="tl dbi">产品</span> </div>
              <div class="w68 fl">
                <ul class="li-div-txt">
                  <li class="" style="width:23%"> 
                        <a class="dbi  w100 menu-atxt" href="/chanping4">
                          <div class="li-div-d2 mt10 "> 
                            <img src="../assets/images/z13-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">视觉智能体</h1>
                        </a> 
                      </li>
                      <li style="width:23%"> 
                        <a class="dbi w100 menu-atxt" href="/chanping3">
                          <div class="li-div-d2 mt10"> 
                            <img src="../assets/images/z12-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">新一代公共安全视觉智能体</h1>
                        </a> 
                      </li>
                  <li class="" style="width:23%"> <a class="dbi  w100 menu-atxt" href="/chanping1">
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z1-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh20 mt10 dbi">谛视万象多模态视觉大模型</h1>
                    </a> </li>
                  <li style="width:23%"> <a class="dbi  w100 menu-atxt" href="/chanping2" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z2-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh20 mt10 dbi">谛视万象多模态视觉大模型</h1>
                    </a> </li>
                </ul>
              </div>
            </div>
          </li>
          <li><a class="dbi fb w100 menu-atxt" href="/jiejfa1">解决方案</a>
            <div class="li-div" style="width:1300px;">
              <div class="li-div-left fl" style="width:220px" > <span class="tl dbi">解决方案</span> </div>
              <div class="w70 fl" style="height:148px;">
                <ul class="">
                  <li> <a class="dbi  w100 menu-atxt" href="/jiejfa1" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z3-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40 ">公共安全行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/yijii2">
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z4-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">应急行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/chengguan3" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z5-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">城管行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/jiaotong4" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z6-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">交通行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/qiyeigl5" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z7-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">企业管理解决方案</h1>
                    </a> </li>
                </ul>
              </div>
            </div>
          </li>
          <li><a class="dbi fb w100 menu-atxt" href="/severHtml">服务&生态</a></li>
          <li><a class="dbi fb w100 menu-atxt" href="/gywmHtml">关于我们</a></li>
        </ul>
      </div>
    </div>
  </div>
  <!--菜单end--> 
  
  <!--背景图-->
  <div class="top-backgr">
    <div class="top-box-ins-img bgimg"  ></div>
    <div class="top-box-ins-imga1 bgimg2"  ></div>
  </div>
  <!--背景图end--> 
  
  <!--首页大框end--> 
</div>
<!--首页大框--> 
<!--内容大框-->
<div class="main pt84"> 
  
  <!--解决方案-->
  <div class="w100 lh40 tc WOW animate__animated animate__fadeInUp"> 
    <span class="db f48 fb lp2 mt40">视觉大模型一体机</span> 
    <span class="db f24  lp2 mt10 col-gr">Visual large model all-in-one machine</span> 
</div>
  <div class="w80 jz mt40 lh30 f16">
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">产品架构</p>
    <p class="tl mb40 WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;"><strong><span style="color:rgb(255,0,0);">视觉大模型一体机</span></strong>是集成了前沿人工智能视觉大模型平台与高性能计算硬件的一站式智能设备，专为复杂场景下的视觉任务设计。以视觉感知能力为核心，融合前沿科技，为公共安全、交通运输、城市管理、应急管理、水利、智能制造等各领域的视觉分析场景赋智。产品通过多模态感知、实时推理与自适应学习能力，实时监测各领域视觉场景特征、行为和事件等，精准洞察潜在风险，为用户提供开箱即用的视觉分析服务，无需复杂部署，助力各行业智能化升级与跨越式发展。</p>
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">核心能力</p>
    <p class="f16 fb  tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;color:rgb(255,0,0);" >识万物、懂行为、慧感知</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">不仅能够准确检测预定义类别目标，同时可依据自然语言描述实现开放域场景的智能适配。通过创新的深度学习架构，系统展现出强大的环境泛化能力和抗干扰特性，可有效解析包括未见类别在内的多样化视觉信息，为动态场景下的图像理解提供多维度智能分析能力。通过自主突破性技术架构有效解决了传统模型在应对新兴目标类别、复杂场景、复杂行为组合时的局限性，显著提升了跨领域视觉任务的执行效能。</p>
    <!-- <div class="WOW animate__animated animate__fadeInUp "><img src="../assets/images/bg6.jpg" width="50%" height="" class="jz db mt20 mb20  cpjg-e1" alt="" /></div> -->
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">多模式场景应用</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">离线场景解析，满足用户对历史数据详尽研究的需求。可设置视频间隔和增益，同样具备全景解析等功能选项。</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">实时布控预警，通过兼容各类智能终端设备实时数据接入、根据不同应用场景灵活配置预警功能以及实现重点事件实时、准确的布控预警响应。</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">智能终端应用，与机器狗、机器人、智能门锁等带有摄像头的智能终端联通 ，赋能大模型分析能力 ，实现具身智能等场景应用。</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">回溯任务解析，满足用户对过去特定时段数据重新分析的需求。可在直播模式和打标模式间抉择。</p>
    <div class="WOW animate__animated animate__fadeInUp "><img src="../assets/images/bg7.jpg" width="50%" height="" class="jz db mt20 mb20  cpjg-e1" alt="" /></div>
    <p class="f16 fb mt20 tl  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">全维度、全要素结构化分析</p>
    <p class="tl  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;">全结构化解析检索，对采集的视频、图像数据进行全面深入解析，构建结构化索引。</p>
    <p class="tl  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;">自动打标高效能，对预警图像自动生成文字描述、智能标签，形成文本知识库。</p>
    <p class="tl  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;">高准多条件检索，可通过多种条件快速检索所需信息，可依据多维度信息快速定位相关视频、图像或文本数据。</p>
    <p class="tl mb20  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;">全国产化生态支持，完全适配自主可控的国产化IT底层架构和生态体系，全面支持华为鲲鹏+昇腾、海光+DCU等、飞腾国产化硬件技术路线；支持主流音视频标准化协议，如GB/T28181、GA/T1400、RTSP、ONVIF、FTP等。同时兼容海康威视、大华、宇视等主流设备厂商智能设备。</p>
    <div class="WOW animate__animated animate__fadeInUp "><img src="../assets/images/bg8.jpg" width="50%" height="" class="jz db mt20 mb20  cpjg-e1" alt="" /></div>
    <p class="f20 fb mb30 tc  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.9s;">产品优势</p>
    <p class="f16 fb mt20 tl  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.9s;color:rgb(255,0,0);">【分钟级算法创建、小时级部署上线、零样本训练、软硬一体化设计】</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.9s;">分钟级算法创建，依托先进的自然语言处理和机器学习技术，用户仅需通过简洁文字描述，就能在分钟内完成复杂场景算法的定制。</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.9s;">小时级部署上线，高效一站式部署，从算法创建完成到上线使用，仅需小时级时间使新算法能迅速投入实际业务场景。</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.9s;">零样本训练，打破传统算法依赖大量样本训练的局限，在0样本数据的情况下，对新出现的目标或场景进行识别。</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.9s;">软硬一体化设计，工业级机箱，支持多种部署模式，适应各类场景需求。内置模型管理平台，零代码完成任务配置与结果分析。</p>
	
  </div>
  <!--解决方案end--> 
  <!--产品-->
  <div class="cpjg jz clearfloat ov mt50">
  <p class="f20 fb mb30 tc mt40  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.9s;">国产设备</p>
    <div class="fl wi388 he542">
      
      <div class="wi387 he261 ov WOW animate__animated animate__fadeInLeft"><img src="../assets/images/y-b-11a.jpg"   alt=""/></div>
      <div class="wi387 he261 mt6 ov WOW animate__animated animate__fadeInLeft" style="animation-delay: 0.3s;"><img src="../assets/images/y-b-12a.jpg"   alt=""/></div>
    </div>
    <div class="fr wi902 he529 ov WOW animate__animated animate__fadeInRight" style="animation-delay: 0.2s;"><img src="../assets/images/y-b-10a.jpg"  alt=""/></div>
  </div>
  <div class="cpjg jz clearfloat ov mt50">
  <p class="f20 fb mb30 tc mt40  WOW animate__animated animate__fadeInUp" style="animation-delay: 0.9s;">进口设备</p>
    <div class="fr wi388 he542">
      
      <div class="wi387 he261 ov WOW animate__animated animate__fadeInRight"><img src="../assets/images/y-b-11.jpg"   alt=""/></div>
      <div class="wi387 he261 mt6 ov WOW animate__animated animate__fadeInRight" style="animation-delay: 0.3s;"><img src="../assets/images/y-b-12.jpg"   alt=""/></div>
    </div>
    <div class="fl wi902 he529 ov WOW animate__animated animate__fadeInLeft" style="animation-delay: 0.2s;"><img src="../assets/images/y-b-10.jpg"  alt=""/></div>
  </div>
  <!--产品end--> 
</div>
<!--内容大框end--> 
<!--底宣-->
<div class="btto-a1 mt100 ov">
      <div class="btto-a2 jz mt30">
        <ul class="w100 he68">
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;">
            <div class="btt-ico fl ">
              <img src="../assets/images/za1-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">全场景算法</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">algorithm</span>
              </div>
              <div class="mt4 col-gr3">多种行业全场景算法</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.3s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za2-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">算法灵活自定义</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Custom</span>
              </div>
              <div class="mt4 col-gr3">可通过文字自定义描述方式新增修改</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.5s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za3-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">国产化生态支持</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">support</span>
              </div>
              <div class="mt4 col-gr3">基于自主可控的国产化IT底层架构</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.7s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za4-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">完善标准化</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">standardization</span>
              </div>
              <div class="mt4 col-gr3">支持主流音视频标准化协议</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.9s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za5-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">大模型技术</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Large Model</span>
              </div>
              <div class="mt4 col-gr3">使用Transformer架构</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
<!--底宣end--> 
 <!--底宣2-->
    <div class="btto-b-a1 ov">
      <div class="mt30 w100 jz dbi">
        <div class="tc WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;"> <img src="../assets/images/ying-28.jpg" width="76" height="76" alt="" class="  dbi " /></div>
        <ul class="w100 he92 tc mt20">
          <li class=" WOW animate__animated animate__fadeInRight animate__duration-5s dbi" style="animation-delay: 0.1s;">
            <div class="tl f24 white he35 fl">上海谛视万象科技有限公司</div>
            <div class="ov  fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_3.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">联系电话：4007628008</span>
            </div>
          <!--  <div class="ov fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_1.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">地址：上海市徐汇区龙爱路27号芒果广场A座1906室</span>
            </div>-->
          </li>
                   
        </ul>
      </div>
    </div>
    <!--底宣2end--> 
<!--底宣3-->
<div class="he90 tc btto-c"><span class="dbi col-gr3  mt30 mr40">辽ICP备2025061615号</span> <span class="dbi col-gr3  mt30">Copyright © 2004 - 2025 谛视万象版权所有</span></div>
<!--底宣3end-->
</div>
</template>
<script setup>
// , onUpdated, onUnmounted, ref
import { onMounted } from 'vue';
import * as WOW from 'wowjs';
// let wowInstance = null;
onMounted(() => {
    new WOW.WOW({
        // boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 50,       // 元素进入视口 100px 后触发
        // mobile: true,      // 移动端启用
        live: true,        // 监听动态添加的元素
    }).init();
})
</script>
<style scoped>
@import '@/assets/css/default.css';
@import '@/assets/css/font-awesome.min.css';
@import '@/assets/css/margin.css';
@import '@/assets/css/main.css';

/* style="background:url(../assets/images/bana-9.jpg) center center no-repeat;background-size:cover;" */
/* style="background:url(../assets/images/z8-ytj.png) center center no-repeat;background-size:cover;" */
.bgimg{
    background:url(../assets/images/bana-9.jpg) center center no-repeat;
    background-size:cover;
}

.bgimg2{
    background:url(../assets/images/z8-ytj.png) center center no-repeat;
    background-size:cover;
}

.animate__animated {
  animation-duration: 2s !important;
}

</style>